////////////////////////////////////////////////////////////////////////////////
//
// Dispenser API module
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

////////////////////////////////////////////////////////////////////////////////

const dispenser = {
    /**
     * Get all accounts
     * @returns {Promise<AxiosResponse<any>>}
     */
    all: () => ApiService.getT('dispenser'),

    /**
     * Add a account with data
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    add: (data) => ApiService.postT('dispenser', data),

    /**
     * Delete account with name
     * @param name
     * @returns {Promise<AxiosResponse<any>>}
     */
    del: (name) => ApiService.deleteT(`dispenser/${name}`),

    /**
     * Save Site with data
     * @param name dataview resource name
     * @param data { "description": "", "name": "", ... }
     */
    save: (name, data) => {
        const dataCopy = { ...data }
        if (name === dataCopy.name) {
            delete dataCopy.name
        }
        const putData = { operator: { $set: dataCopy } }
        return ApiService.putT(`dispenser/${name}`, putData)
    },

    /**
     * Put a device into the dispenser
     * @param device
     * @param dispenser
     */
    putDevice: (dispenser, device) => {
        return ApiService.postT(`dispenser/${dispenser}/put/${device}`)

    },
    uploadGroupFile(formData) {
            return ApiService.postT('file', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
    
  listGroupFirmware(groupId, siteId, deviceType = 'CC2', includeEntity = false) {
    const params = {
        group_id: groupId,
        level: 'group',
        site_id: siteId,
    };
    if (includeEntity) {
        params.include_entity = true;
    }
    return ApiService.getT(`firmware/list/${deviceType}`, { params });
},
    deleteGroupFile(fileId) {
        return ApiService.deleteT(`file/${fileId}`);
     },
    deleteAllGroupFiles(groupId)  {
        return ApiService.deleteT('files', {
            params: {
                level: 'group',
                group_id: groupId
            }
        });
    },

    uploadGroupFirmware(formData) {
       return ApiService.postT('firmware', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },

    listGroupFirmware(groupId, siteId, deviceType = 'CC2', includeEntity = false) {
          //  console.log('listGroupFirmware called with includeEntity:', includeEntity);

    const params = {
        group_id: groupId,
        level: 'group',
        site_id: siteId,
    };
    if (includeEntity) {
        params.include_entity = true;
    }
    return ApiService.getT(`firmware/list/${deviceType}`, { params });
},
      
    deleteGroupFirmware(firmwareId) {
       return ApiService.deleteT(`firmware/${firmwareId}`)
      },
      

    deleteAllGroupFirmware(groupId, deviceType = 'CC2') {
       return ApiService.deleteT('firmware', {
        params: {
            level: 'group',
            group_id: groupId
        }
    });
          },

              uploadGroupIcon(formData) {
        return ApiService.postT('icon', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    
    listGroupIcons(groupId, siteId) {
       //console.log("Listing group icons with:", { groupId, siteId });
        return ApiService.getT('icon', {
            params: {
                level: 'group',
                group_id: groupId,
                site_id: siteId
            }
        });
    },
    
    deleteGroupIcon(iconId) {
        return ApiService.deleteT(`file/${iconId}`); // Icons use same file delete endpoint
    },
    
    deleteAllGroupIcons(groupId) {
        return ApiService.deleteT('files', {
            params: {
                level: 'group',
                group_id: groupId,
                is_icon: true // Filter for icons only
            }
        });
    }
    }

export default dispenser;